export enum RadioSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}
